const state = {
  userinfo: {},
  token: null,
  title: '',
  examData: {},
  questData: {},
  product: {},
  scrollInfo: {},
  competitionID: {}
}

export default state